import type { NormalizedTemplateCategoryT } from 'shared/cms/templateCategories/normalizeTemplateCategory';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Section, Wide } from '../layout';
import MobileNavigation from './MobileNavigation';
import NavigationContent from './NavigationContent';

interface Props {
  children: React.ReactNode;
  categories?: NormalizedTemplateCategoryT[];
}

const Fade = ({ placement }: { placement: 'top' | 'bottom' }) => {
  return (
    <Box
      height={placement === 'top' ? '6px' : '10px'}
      width="100%"
      position="absolute"
      bottom={placement === 'top' ? undefined : '0'}
      top={placement === 'top' ? '0' : undefined}
      left="0"
      extend={() => ({
        background:
          placement === 'top'
            ? 'linear-gradient(white, rgba(255, 255, 255, 0))'
            : 'linear-gradient(rgba(255, 255, 255, 0), white)',
      })}
    />
  );
};

const CategoryNavigation = ({ categories, children }: Props) => {
  return (
    <>
      <Box
        zIndex={4}
        extend={({ theme }) => ({
          [`@media not screen and (max-width: ${theme.breakpoints[1]})`]: {
            display: 'none',
          },
        })}
      >
        <MobileNavigation categories={categories ?? []} />
      </Box>
      <Section overflow="unset" px={['space8', null]}>
        <Wide flexDirection="row">
          <Box
            mr="space16"
            width="14rem"
            position="sticky"
            top="80px"
            extend={({ theme }) => ({
              [`@media screen and (max-width: ${theme.breakpoints[1]})`]: {
                display: 'none',
              },
            })}
          >
            <Box
              maxHeight="calc(100vh - 80px)"
              overflow="scroll"
              extend={() => ({
                '::-webkit-scrollbar': {
                  display: 'none',
                },
                '-ms-overflow-style': 'none',
                scrollbarWidth: 'none',
              })}
            >
              <NavigationContent categories={categories ?? []} />
            </Box>
            <Fade placement="top" />
            <Fade placement="bottom" />
          </Box>
          <Box flex="1 1 auto">{children}</Box>
        </Wide>
      </Section>
    </>
  );
};

export default CategoryNavigation;
